<h1 class="progress-bar-header" data-test="profile-completion-header">{{ progressBarHeader }}</h1>

<iris-progress-bar
  *ngIf="showProgress"
  [isIndeterminateLoading]="!showProgress"
  [percentComplete]="progressBarValue"
  class="account-completion-progress"
></iris-progress-bar>
<span *ngIf="!showProgress"> <br/> </span>
